import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '被依赖',
    type: 'MIDINS_DEPENDENCE_BY',
}
